"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tone = require("tone");

var _tone2 = _interopRequireDefault(_tone);

var _util = require("./util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Kalimba
 * @module lib/kalimba.js;
 */

var player_count = 4;

var samples = [{ root: 219.5, fn: "samples/380737__cabled-mess__sansula-01-a-raw.wav" }, { root: 260.9, fn: "samples/380736__cabled-mess__sansula-02-c-raw.wav" }, { root: 330.2, fn: "samples/380735__cabled-mess__sansula-03-e-raw.wav" }];

function load(_ref) {
  var output = _ref.output;

  samples.forEach(function (sample) {
    sample.players = [];
    sample.index = -1;
    for (var i = 0; i < player_count; i++) {
      var fn = sample.fn;
      if (window.location.href.match(/asdf.us/)) {
        fn = "//asdf.us/kalimba/" + fn.replace("wav", "mp3");
      }
      var player = new _tone2.default.Player({
        url: fn,
        retrigger: true,
        playbackRate: 1
      });
      player.name = fn;
      var gain = new _tone2.default.Gain(0.15);
      player.connect(gain);
      gain.connect(output);
      sample.players.push(player);
    }
  });
  console.log("+ Voices:", samples.reduce(function (count, sample) {
    return count + sample.players.length;
  }, 0));
}

function play(interval, root) {
  var sample = (0, _util.choice)(samples);
  sample.index = (sample.index + 1) % sample.players.length;

  var player = sample.players[sample.index];
  player.playbackRate = interval * root / sample.root;
  player.start();
}

function pause() {
  // no-op
}

exports.default = { load: load, play: play, pause: pause };

// for help tuning the kalimba samples
// function keydown(e) {
//   // console.log(e.keyCode)
//   if (e.metaKey && last) {
//     let step = e.shiftKey ? (e.ctrlKey ? 0.01 : 0.1) : 1;
//     switch (e.keyCode) {
//       case 38: // up
//         e.preventDefault();
//         samples[0].root -= step;
//         play(last);
//         break;
//       case 40: // down
//         e.preventDefault();
//         samples[0].root += step;
//         play(last);
//         break;
//     }
//     console.log(samples[0].root);
//   }
// }
// window.addEventListener("keydown", keydown, true);


//////////////////
// WEBPACK FOOTER
// ./client/lib/kalimba.js
// module id = 262
// module chunks = 0